import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base';
import { SessionService, StepsIdEnum, RequestTypesEnum, LookupsService, CompaniesEnum, BuildingType, LDCEnum,
   LimitlessUiService, ConstantsService } from '@app/base/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiResult, SocoHttpService } from '@app/base/soco';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Attachment } from '@app/base/core/models';
import { map } from 'rxjs/operators';
import { v4 } from 'uuid';
import { process, State } from '@progress/kendo-data-query';
import { DataStateChangeEvent, GridDataResult, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { isNullOrUndefined } from 'util';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'residential-premise',
  templateUrl: './residential.premise.component.html',
})
export class ResidentialPremiseComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('siteplan', {static: false}) siteplan: ElementRef;
  form: FormGroup;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  selectedIDsforResidential: any[] = [];
  selectedIDsforResForm: any[] = [];
  deliveryPressOthersResidential = false;
  typeForm: FormGroup;
  applianceCountR = true;
  buildingTypeList: BuildingType[] = [];
  ldcEnum: typeof LDCEnum = LDCEnum;
  residentialPressure = this.lookupSvc.defaultResidentialPressure.lookupValues[0];
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  public btuLoadVal = 'BTU Load Value (Optional)';
  StatusSearchResults: Attachment[];
  public SearchResultsGridView: GridDataResult;
  selectedRecord: Attachment = new Attachment();
  getFilesSubscription: Subscription;
  deleteFilesSubscription: Subscription;
  AttachmentList: string[] = [];
  defaultSkip = 0;
  defaultItemsPerPage = 5;
  public rowValue: string;
  public pageSizes = true;
  public previousNext = true;
  public statevalue: SelectAllCheckboxState = 'unchecked';
  documentInput: any = {};
  // public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public take = 5;
  public state: State = {
    skip: this.defaultSkip,
    take: this.defaultItemsPerPage,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public mySelection: string[] = [];
  flagExt = false;
  flagSize = false;
  public items: any[];
  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    if (this.socoHttp.sessionActive) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantsSvc.changes;
    }
  }
  constructor(public wizardSvc: MultistepsService, private constantsSvc: ConstantsService, public socoHttp: SocoHttpService,
     public sessionSvc: SessionService, public lookupSvc: LookupsService, public limitlessSvc: LimitlessUiService,
     private config: SocoConfigurationService, private http: HttpClient) {
  }
  ngOnInit() {
    this.documentInput.Folder = this.constantsSvc.folderName;
    const builderID = this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id === undefined ? this.wizardSvc.BId :
    this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id;
    this.wizardSvc.BId = builderID;
    this.refreshGrid();
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form;
    this.typeForm = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;
    const resPremiseArray = <FormArray>this.form.controls['residentialFormArray'];
    resPremiseArray.controls.forEach((element, i) => {

      if (isNullOrUndefined(element.get('residentialDeliveryPressure').value)) {
        element.patchValue({
          residentialDeliveryPressure: this.residentialPressure,
        });
      }

      if (this.wizardSvc.serviceAddress.state.short_name === this.companiesEnum.FL) {
        element.get('residentialPropertyOwner').setValidators(Validators.required);
      }
      if ((element.get('residentialDeliveryPressure').value &&
      element.get('residentialDeliveryPressure').value['itemName'].toUpperCase() === this.constantsSvc.other) ||
       element.get('residentialDeliveryPressureOthers').value !== ''
       && !isNullOrUndefined(element.get('residentialDeliveryPressureOthers').value)) {
       this.deliveryPressOthersResidential = true;
     } else {
       this.deliveryPressOthersResidential = false;
       element.get('residentialDeliveryPressureOthers').clearValidators();
       element.get('residentialDeliveryPressureOthers').updateValueAndValidity();
     }
      const formArray = <FormArray>element.get('appliancesforResidential');
      if (formArray.length > 49) {
        this.applianceCountR = false;
      }
    });

    // Logic to populate building Type List
    this.buildingTypeList = this.lookupSvc.buildingTypes.filter(b => b.unitType === this.constantsSvc.residentialType &&
      (this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.GA ? b.market === this.ldcEnum.AGLC :
        this.wizardSvc.serviceAddress.state.short_name.toUpperCase() === this.companiesEnum.TN ? b.market === this.ldcEnum.CGC :
          b.market === this.ldcEnum.VNG));

    if (this.typeForm.value.propertyType.itemName === this.constantsSvc.multi_Family) {
      this.form.controls.residentialFormArray['controls'].forEach((item) => {
        const a = this.buildingTypeList.find(x => x.id === this.constantsSvc.multiFamilyBuildingType);
        item.controls.residentialBuildingType.setValue(a);

      });
      this.form.controls.residentialFormArray.updateValueAndValidity();
    }
  }

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState:
    RouterStateSnapshot) {
    if (this.form) {
      return this.wizardSvc.canDeactivateStep(route, state, nextState);
    } else {
      return true;
    }
  }

     // To Add Premise Details for Residential Premise
     addpremiseForResidential() {
      const formArray = <FormArray>this.form.controls['residentialFormArray'];
      const panelIndex = formArray.controls.length;
      formArray.push(new FormGroup({
        panelNumber: new FormControl(panelIndex + 1),
        residentialHomeSqFt: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
        residentialApproxDistanceFt: new FormControl('', Validators.pattern(this.constantsSvc.numericPattern)),
        residentialDeliveryPressure: new FormControl(this.lookupSvc.defaultResidentialPressure.lookupValues[0], Validators.required),
        residentialNoOfUnit: new FormControl('', Validators.pattern(this.constantsSvc.numericPattern)),
        // TODO: change true to check for value of new construction in type step to 'Yes'
        residentialStatusofConstruction: new FormControl(null, [Validators.required]),
        residentialUnitDescription: new FormControl(null, [Validators.required]),
        residentialNeedingServiceDate: new FormControl('', [Validators.pattern(this.constantsSvc.dateValidator)]),
        // TODO: change true to check for value of selected serviceable state in location page to 'Florida'
        residentialPropertyOwner: new FormControl(''),
        // TODO: change true to check for value of residentialDeliveryPressure to 'Other'
        residentialDeliveryPressureOthers: new FormControl(''),
        residentialBuildingType: new FormControl(null, [Validators.required]),
        appliancesforResidential: new FormArray([new FormGroup({
          defaultAppliance: new FormControl(null, [Validators.required]),
          defaultApplianceOther: new FormControl(null),
          quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
          defaultValue: new FormControl('', [Validators.pattern(this.constantsSvc.numericPatternwithZero)])
        })])
      })
      );

    }
// Adding appliances for Residential premise
  addAppliancesforResidential(element) {
    const formArray = <FormArray>element.get('appliancesforResidential');
    formArray.push(new FormGroup({
      defaultAppliance: new FormControl(null, [Validators.required]),
      defaultApplianceOther: new FormControl(null),
      quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
      defaultValue: new FormControl('', [Validators.pattern(this.constantsSvc.numericPatternwithZero)]),
      existingLoad: new FormControl(false)
    })
    );
    if (formArray.length > 49) {
      this.applianceCountR = false;
    }
  }
  // delete appliances of Residential premise
  deleteApplianceforResidential(element) {
    const control = <FormArray>element.get('appliancesforResidential');

   if (this.selectedIDsforResidential.length === 0) { swal(this.constantsSvc.premiseSwal1, this.constantsSvc.premiseSwal2); }
    this.selectedIDsforResidential.sort((a, b) => b - a);
    this.selectedIDsforResidential.forEach(function (index) {
      control.removeAt(index);
    });
    if (control.length < 50) {
      this.applianceCountR = true;
    }
    this.selectedIDsforResidential = [];
  }

  // delete  Residential premise
  selectIdfordeletion(id) {
    const control = <FormArray>this.form.controls['residentialFormArray'];
    control.removeAt(id);
  }
// Select appliance IDs for deletion
  selectIDforResidential(id, event: any) {
    if (event.target.checked) {
      this.selectedIDsforResidential.push(id);
    } else if (!event.target.checked) {
      const index = this.selectedIDsforResidential.indexOf(id);
      this.selectedIDsforResidential.splice(index, 1);
    }
  }

  // Selection of delivery pressure required
  onItemSelect(eve: any, resArr: FormGroup) {
    if (isNullOrUndefined(eve)) {
      resArr.controls['residentialDeliveryPressureOthers'].reset('');
      resArr.controls['residentialDeliveryPressureOthers'].clearValidators();
      resArr.updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
    } else if (eve.itemName === this.constantsSvc.other) {
      this.deliveryPressOthersResidential = true;
      this.form.controls['residentialDeliveryPressureOthers'].setValidators([Validators.required]);
    } else {
      resArr.controls['residentialDeliveryPressureOthers'].reset('');
      resArr.controls['residentialDeliveryPressureOthers'].clearValidators();
      resArr.controls['residentialDeliveryPressureOthers'].updateValueAndValidity();
      this.deliveryPressOthersResidential = false;
      resArr.updateValueAndValidity();
    }
    resArr.updateValueAndValidity();
  }
  // Selection of appliance
  onApplianceSelected(item: any, appArr: FormGroup, resArr: FormGroup) {
    this.btuLoadVal = this.constantsSvc.btuLoadOption;
    appArr.controls['defaultValue'].reset(null);
    appArr.controls['defaultValue'].clearValidators();
    appArr.controls['defaultApplianceOther'].reset(null);
    appArr.controls['defaultApplianceOther'].clearValidators();
    if (item['itemName'].toUpperCase() === this.constantsSvc.other) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultApplianceOther'].setValidators(Validators.required);
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultApplianceOther'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
    } else if ((item['itemName'] === this.constantsSvc.poolHeater) || (item['itemName'] === this.constantsSvc.standbyGenerator)) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultValue'].setValidators(Validators.pattern(this.constantsSvc.numericPatternwithZero));
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
    } else {
      this.btuLoadVal = this.constantsSvc.btuLoad;
      const homeSqFt = resArr.controls['residentialHomeSqFt'].value;
      const requestType = item.usageType.toUpperCase() ==='RESIDENTIAL' ? 'RES':'COMM';
    
      const loadValue = this.lookupSvc.wrLoadArmLkp.filter(load => 
        load.loadTypeCode === item.id && load.resiComm === requestType &&
        ((load.minSqFTG === null || load.minSqFTG <= homeSqFt) &&
        (load.maxSqFTG === null || load.maxSqFTG >= homeSqFt))
        );

    if(loadValue.length > 0)
    {
      appArr.controls['defaultValue'].setValue(loadValue[0]['itemName']);
        }

      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultValue'].setValidators([Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
    }
    appArr.updateValueAndValidity();
  }

  // File Upload Functionality For subdivision File.
  onFileChange(event) {

    // File Array varaiable
    const files: FileList = event.target.files;
    if (files.length > 5) {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.maxdocSwal, this.constantsSvc.errorSwal);
    } else if (this.SearchResultsGridView !== undefined) {
      const count = this.SearchResultsGridView.total + files.length;
      if (count > 5) {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.maxdocSwal, this.constantsSvc.errorSwal);
      } else {
        this. fileSize(files);
      }
    } else {
      this. fileSize(files);
    }
  }

  fileSize(files) {
    this.flagSize = false;
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > 50000000) {
        this.flagSize = true;
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.maxDocSize, this.constantsSvc.errorSwal);
      }
    }
    if (this.flagSize === false) {
      this.filetype(files);
    }
  }

  filetype(files) {
    this.flagExt = false;
    const extArr = ['.jpg', '.gif', '.png', '.txt', '.asm', '.doc', '.docx', '.docm', '.dot', '.dotx',
    '.dotm', '.jpe', '.jpeg', '.pdf', '.pnz', '.ppt', '.pptm', '.pptx', '.tiff', '.tif', '.xlc', '.xls', '.xlsx', '.xlsm', '.xlt'];
    for (let i = 0; i < files.length; i++) {
      const ext = files[i].name.substr(files[i].name.indexOf('.'));
      if (extArr.indexOf(ext.toLowerCase()) === -1 ) {
        this.flagExt = true;
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.wrongExt + ' ' + files[i].name, this.constantsSvc.errorSwal);
      }
    }
    if (this.flagExt === false) {
      this.fileUpdate(files);
    }
  }

  fileUpdate(files) {
    // formData variable for pushing in file data
    const formData = new FormData();
    // variable to store file which already exists with the same name.
    const dupfile = [];
    const selectedFiles = [];
    // Check if the File array length is greater than 0
    if (files.length > 0) {
      // if any uploaded file in the list of files is empty, Display error and do not upload any files.
      for (let i = 0; i < files.length; i++) {
        if (files.item(i).size <= 0) {
          swal(
            this.constantsSvc.errorSwal1,
            files.item(i).name + this.constantsSvc.fileUpload,
            this.constantsSvc.errorSwal
          );
          break;
        } else if (this.SearchResultsGridView !== undefined && this.SearchResultsGridView.data.length !== 0) {
          if (this.SearchResultsGridView.data.some( childData => {
            return childData.name === files.item(i).name;
          })) {
            dupfile.push(files.item(i));
          } else if ( !selectedFiles.includes(files.item(i).name) && !dupfile.includes(files.item(i))) {
            formData.append(files.item(i).name, files.item(i));
          }
        } else if ( !selectedFiles.includes(files.item(i).name) ) {
          selectedFiles.push(files.item(i).name);
          formData.append(files.item(i).name, files.item(i));
        }
      }

      // If the dupfile array is empty proceed to uploadfile function.
      // else display swal alert to the user and if user selects true add the dup file data to the form data and upload.
      // else return without any file upload.
      if (dupfile !== undefined && dupfile.length > 0) {
        const message = this.constantsSvc.dupFileMsg;
        const msg = document.createElement('div');
        msg.innerHTML = message;
        swal({
          content: msg,
          icon: 'assets/images/icons/icon_94_tumbs-up-green.svg',
          buttons: {
            cancel: {
              text: 'Cancel',
              visible: true,
              value: false,
              closeModal: true
            },
            confirm: { text: 'Proceed', value: true, closeModal: true }
          }
        }).then(result => {
          if (!result) {
            return;
          } else {
            for (let k = 0; k < dupfile.length; k++) {
              formData.append(dupfile[k].name, dupfile[k]);
            }
            this.UploadFile(formData);
          }
        });
      }
      if (formData !== null && !(dupfile.length > 0)) {
        this.UploadFile(formData);
      }
    }
    this.siteplan.nativeElement.value = '';
  }

  UploadFile(formData: FormData) {

    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    const builderID = this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id === undefined ? this.wizardSvc.BId :
    this.wizardSvc.steps[StepsIdEnum.INFORMATION].form.value.builderCompany.id;
    this.documentInput.BuilderId = builderID;
    formData.append('folder', this.documentInput.Folder);
    formData.append('builderId', builderID);
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: 'Bearer ' + this.config.webApiToken,
      'x-transaction-id': this.getGuid(),
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    });
    this.http
      .post(
        this.config.webApiBaseUrl + 'SubDivisionFiles/Upload?builderId=' + builderID,
        formData,
        {headers: headers},
      ).pipe(
      map(res => res as ApiResult<any>))
      .subscribe(a => {
        if (a.data != null) {
          this.items = a.data;
          this.StatusSearchResults = this.items;
          this.SearchResultsGridView = process(
            this.StatusSearchResults,
            this.state
          );
          this.socoHttp.hidePleaseWait('ContainerAwaiter');
          swal(this.constantsSvc.successSwal1, this.constantsSvc.fileUpload1, this.constantsSvc.successSwal);
        }
      },
      err => {
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.fileUploadFail, this.constantsSvc.errorSwal);
      });
  }

  /// This method is copied from  Soco http Service to create GUid for adding to the header to normal http post.
  /// Instead of using the Soco Http post which does not support file upload.
  private getGuid(): string {
    const hexlist = '0123456789abcdef';
    const b64list =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    function guidToBase64(
      guid: string,
      shouldUseLittleEndian: boolean
    ): string {
      let parsedGuid = guid.replace(/[^0-9a-f]/gi, '').toLowerCase();
      if (parsedGuid.length !== 32) {
        return '';
      }

      if (shouldUseLittleEndian) {
        parsedGuid =
          parsedGuid.slice(6, 8) +
          parsedGuid.slice(4, 6) +
          parsedGuid.slice(2, 4) +
          parsedGuid.slice(0, 2) +
          parsedGuid.slice(10, 12) +
          parsedGuid.slice(8, 10) +
          parsedGuid.slice(14, 16) +
          parsedGuid.slice(12, 14) +
          parsedGuid.slice(16);
      }
      parsedGuid += '0';

      let result = '';
      let i = 0;
      let a: any, p: any, q: any;
      while (i < 33) {
        a =
          (hexlist.indexOf(parsedGuid.charAt(i++)) << 8) |
          (hexlist.indexOf(parsedGuid.charAt(i++)) << 4) |
          hexlist.indexOf(parsedGuid.charAt(i++));

        p = a >> 6;
        q = a & 63;

        result += b64list.charAt(p) + b64list.charAt(q);
      }
      result += '==';

      return result;
    }

    // generate a guid
    const guid = v4();

    // base-64 encode the guid using Little-endian
    const b64encoded = guidToBase64(guid, true);

    // return the 22 character guid
    return b64encoded
      .replace('/', '_')
      .replace('+', '-')
      .substring(0, 22);
  }

  // To fetch documents if any of logged in builder
  documentFetch() {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.getFilesSubscription = this.wizardSvc.getAllFiles(this.wizardSvc.BId).subscribe(result => {
      if (result.data != null) {
        (this.items = result.data), (this.StatusSearchResults = this.items);
        this.SearchResultsGridView = process(
          this.StatusSearchResults,
          this.state
        );
      }
      this.AttachmentList = [];
      this.socoHttp.hidePleaseWait('ContainerAwaiter2');
    });
  }

  // unsubscribe subscriptions
  ngOnDestroy() {
    if (this.getFilesSubscription) {
      this.getFilesSubscription.unsubscribe();
    }
    if (this.deleteFilesSubscription) {
      this.deleteFilesSubscription.unsubscribe();
    }
  }

  // Delete files
  deleteFiles() {
    if (this.AttachmentList.length !== 0) {
      this.deleteFilesSubscription = this.wizardSvc.deleteFiles(this.wizardSvc.BId, this.AttachmentList).subscribe(result => {
      if (result.data != null) {
        (this.items = result.data), (this.StatusSearchResults = this.items);
        this.SearchResultsGridView = process(
          this.StatusSearchResults,
          this.state
        );
        this.mySelection = [];
        this.statevalue = 'unchecked';
        this.AttachmentList = [];
      }
      });
    } else {
    swal (this.constantsSvc.errorSwal1, this.constantsSvc.emptyListSwal, this.constantsSvc.errorSwal);
    }
  }

  // To refresh grid
  refreshGrid() {
    this.mySelection = [];
    this.statevalue = 'unchecked';
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    if (this.wizardSvc.BId !== null && this.wizardSvc.BId !== undefined) {
      this.documentFetch();
    }
  }

  // Binding data on statechange
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.take = state.take;
    this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
  }
// For Excel Export
  public allData(): ExcelExportData {
    return {
      data: process(this.StatusSearchResults, {}).data
    };
  }
// Attachment Selection
  selectionChange(ev: any) {
    if (ev.selectedRows.length !== 0) {
      for (let i = 0; i < ev.selectedRows.length; i++) {
        this.AttachmentList.push(ev.selectedRows[i].dataItem.name);
      }
    } else {
      for (let i = 0; i < ev.deselectedRows.length; i++) {
        this.AttachmentList.splice(ev.deselectedRows[i].dataItem.name, 1);
      }
    }
    this.rowValue = ev.index;
    this.selectedRecord = this.StatusSearchResults[this.rowValue];
  }

  public mySelectionKey(context: RowArgs): string {
    return context.dataItem.ProductName + ' ' + context.index;
  }
  // Selecting all files
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === 'checked') {
      this.mySelection = [];
      this.mySelection = this.items.map(item => item.name);
      this.statevalue = 'checked';
    } else {
      this.mySelection = [];
      this.statevalue = 'unchecked';
    }
  }

}
